/**
 * 学习乐园 · 连连看题材包：音乐记号（lianliankan/pack-yinfu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：记号连含义（「四分音符」连「唱一拍」）。牌面用记号的
 * 中文名而不是符号图形——♯♭♮ 这类字符能显示，音符时值的字形
 * 各设备差异大，中文名先立得住，符号写进 note 当记忆抓手。
 * 内容是简谱与五线谱共用的基本记号：音符时值、谱号、升降号、
 * 力度与奏法记号、拍号。与琴谱跟弹页同一条音乐线。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.yinfu = {
    id: 'yinfu',
    name: '音乐记号',
    hint: '记号连它表示的意思',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '四分音符', r: '唱一拍', note: '实心符头加符干，最常见' },
      { l: '二分音符', r: '唱两拍', note: '空心符头加符干' },
      { l: '全音符', r: '唱四拍', note: '空心符头没有符干' },
      { l: '八分音符', r: '唱半拍', note: '符干上带一条尾' },
      { l: '十六分音符', r: '唱四分之一拍', note: '符干上带两条尾' },
      { l: '附点二分音符', r: '唱三拍', note: '附点把时值加长一半' },
      { l: '休止符', r: '空拍不发声', note: '音乐里的「留白」' },
      { l: '高音谱号', r: '记第二线的 G', note: '从第二线起笔，所以叫 G 谱号' },
      { l: '升记号', r: '升高半音', note: '形状像井号 #' },
      { l: '降记号', r: '降低半音', note: '形状像小写字母 b' },
      { l: '还原记号', r: '取消升降', note: '同一小节内有效' },
      { l: '渐强记号', r: '由弱到强', note: '开口越来越大的角' },
      { l: '渐弱记号', r: '由强到弱', note: '开口越来越小的角' },
      { l: '反复记号', r: '这一段再奏一遍', note: '两点加双竖线' },
      { l: '延音记号', r: '自由延长', note: '眼睛一样的弧形记号' },
      { l: '连音线', r: '圆滑连贯地奏', note: '弧线把音连成一句' },
      { l: '4/4 拍号', r: '每小节四拍', note: '四分音符为一拍，强弱次强弱' },
      { l: '3/4 拍号', r: '每小节三拍', note: '强弱弱，圆舞曲就用它' },
      { l: '低音谱号', r: '记第四线的 F', note: '两点夹着第四线，又叫 F 谱号' },
      { l: '弱记号', r: '轻声地奏', note: '字母 p，piano 一词的来历' },
      { l: '强记号', r: '有力地奏', note: '字母 f，forte' },
      { l: '中强记号', r: '稍响地奏', note: 'mf，比 f 收着点' },
      { l: '中弱记号', r: '稍轻地奏', note: 'mp，比 p 亮一点' },
      { l: '三十二分音符', r: '八分之一拍', note: '符干带三条尾，时值再对半分' },
      { l: '6/8 拍号', r: '每小节六拍', note: '八分音符一拍，强弱弱 次强弱弱' },
      { l: '跳音记号', r: '短促分离地奏', note: '符头上的小圆点，像指尖点水' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
